import React from 'react';
import CountUp from 'react-countup';
import './StatsCounterSection.css';
import { stats } from '../../assets/exports';
import { useInView } from 'react-intersection-observer';

const StatsCounterSection = () => {
  // Setting up intersection observer
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once when in view
    threshold: 0.5, // 50% of the section must be visible
  });

  return (
    <section className="stats" ref={ref}>
      <div className="stats-wrapper">
        {stats.map((item, index) => (
          <div className="stat-item" key={index}>
            <p className="stat-value">
              {inView ? (
                <CountUp end={item.value} duration={2.5} />
              ) : (
                0
              )}
              +
            </p>
            <p className="stat-label">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsCounterSection;